export const transaksiMasukFilter = (
  dropdownTahunAnggaranPemasukan,
  dropdownUnitUsaha
) => {
  return [
    {
      id: "tahun",
      label: "Tahun",
      options: dropdownTahunAnggaranPemasukan,
    },
    {
      id: "id_unit_usaha",
      label: "Unit Usaha",
      options: dropdownUnitUsaha,
    },
  ];
};
